
export const formatAddress = address =>
  `${address.street} ${address.street2 || ''}, ${address.city}, ${address.state}, ${address.zip}`;

export const mapSelectAddressOptions = item => ({
  value: item.id,
  label: formatAddress(item),
});
